<template>
 <div class="notify-panel" style="width: 100%;height:60%;">
     <h2>Notification Panel</h2>
     <div>
       <label> Check Due Amount </label>
     <input type="checkbox" name="check" class="alert" @click="showHighlight()"/>
    
     </div>
     
     <p class="clear"></p>
     
         <v-simple-table
      fixed-header
      height="750px"
    >
    <thead>
        <tr class="hover">
            <th>Invoice ID</th>
            <th> Customer Id</th>
            <th>Customer Name</th>
            <th> Flight Route </th>
            <th> Flight Date </th>
            <th colspan="2"> Amount Due</th>
            
        </tr>
</thead>
        <tr v-for="item in filteredResult" :key="item.id" v-bind:class="{'highlight': (item.invoice.customer.balance >0)}">
            <td><a href="#" @click.prevent="openInvoice(item.invoiceId)">{{item.invoiceId}}</a> </td>
            <td>{{item.invoice.customerId}} </td>
            <td>{{item.invoice.customer.name}} </td>
            <td>{{item.flyFrom}} &rarr; {{item.flyTo}}</td>
            <td>{{item.flightDate}} <span v-if="item.departureTime">{{item.departureTime}}</span></td>
            <td>{{item.invoice.customer.balance.toFixed(2)}} </td>
            <td v-if="item.invoice.customer.balance>0"> <button class="sms"> Payment Reminder SMS </button> </td>
            <td v-else></td>
        </tr>
     </v-simple-table>
 </div>
</template>

<script>

    import { ledgerService } from './../../services/'        
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { EventBus } from './../../eventbus/event-bus.js';

  export default {
    
    name: 'NotificationReport',
    data: () => ({  
       isLoading: true,
        fullPage: true,
        selectedCustomerId:null,
        gridOptions: null,
        tab:null,
        gridApi: null,  
        snackbar: false,
        rowSelection: null,
        notificationReportData:null,
        response:null,
        istick:false,
        filteredResult:[],
        
        
        
    }),
    components: {
        
    },    
    methods: { 
      openInvoice(invoiceId) {
        this.$router.push('/invoices');
        this.$nextTick(() => {
          EventBus.$emit('loadInvoiceById', invoiceId);
        });
      },
      showReport(){
      this.loadTransactions()
      },
      loadTransactions() {
        let self=this        
        self.isLoading=true
        console.log(self.createdAt)
       ledgerService.getUpcomingNotifications().then(data => {              
            self.notificationReportData=data.flights
            self.filteredResult=data.flights
            self.isLoading=false
        })
    },     
    
    showHighlight(){
      if (this.istick==true) {
        this.istick=false;
      }
      else
      {
        this.istick=true;
      }
      if(this.istick==true) {
        this.filteredResult = []
        this.notificationReportData.forEach(item => {
            if(item.invoice.customer.balance>0){
              this.filteredResult.push(item)
            }
        });
      }
      else {
          this.filteredResult=this.notificationReportData
      }
    },

    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();      
      this.selectedCustomerId=selectedRows[0].customerId;
    },
    },
    beforeMount() {
      this.gridOptions = {};
      this.rowSelection = 'single';
      this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,            
    };
    },
    
    mounted () {     
        this.gridApi = this.gridOptions.api;   
        this.loadTransactions()        
    }
}
  
</script>


<style>

.notify-panel table 
{
  width:100%;
  text-align: left;
  border-collapse:collapse;
}
.notify-panel tr:hover
{
    background-color:#e7edf5;
}

.notify-panel .sms
{
  background-color:#e7edf5;
  border:2px solid black;
  padding:10px;
  border-radius: 5px;
 font-weight: bold;
}

.highlight 
{
    background-color:pink;
}
.highlight:hover
{
    background-color:pink !important;
}

.notify-panel th,.notify-panel td 
{
  padding:1%;
  border-bottom:2px solid black;
}
.notify-panel th
{
    font-size:15px;
}

.notify-panel label
{
  float:right;
  margin-right:12%;
  margin-top:-2.2%;
}
.notify-panel .alert
{
  float:right;
  margin-right:20%;
  margin-top:-2%;
  width:15px;
  height:15px;
}


.clear
{
  clear:right;
}
.notify-panel h2 
{
    padding-top: 2%;
    padding-left: 2%;
}
</style>